import { render } from "./forgotPassword.vue?vue&type=template&id=89cecbb8&scoped=true"
import script from "./forgotPassword.vue?vue&type=script&lang=js"
export * from "./forgotPassword.vue?vue&type=script&lang=js"

import "./forgotPassword.vue?vue&type=style&index=0&id=89cecbb8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89cecbb8"]])

export default __exports__